<template>
  <Basket :payFunc="payFunc" :toBasketFunc="toBasketFunc"/>
</template>

<script>
import Basket from "@/components/Basket"

export default {
  props: [ 'payFunc', 'toBasketFunc' ],

  mounted() {
    window.Telegram.WebApp.MainButton.hide()
    // window.Telegram.WebApp.MainButton.onClick(this.payFunc)
    // window.Telegram.WebApp.MainButton.text = `Оплатить ${this.summ} ₽`
  },

  computed: {
    basketItems() {
			return this.$store.getters.basket != undefined 
			       ? Object.values(this.$store.getters.basket) 
						 : []
		},
    summ() {
			return this.basketItems.reduce(
				(accumulator, val) => accumulator + (val.quantity * val.item.price), 0
			)
		},
  },
  
  components: { Basket }
}
</script>

<style>

</style>